import { QuickBuy } from "../App/QuickBuy";

document.addEventListener('DOMContentLoaded', () => {
    const quickBuy = new QuickBuy(endpointUpload, endpointSkuSearch, endpointSkuCheck, searchMinLength);
    quickBuy.init();
});